<template>
  <div class="seat-map-footer">
    <!-- Additional price paid or the selected seats -->
    <div v-if="totalAdditionalPrice !== ''" class="font-size-16px">
      Totale: <span class="semibold">{{ totalAdditionalPrice }} €</span>
    </div>

    <!-- Flight button controls -->
    <div class="seat-map-footer-actions">
      <vb-button
        v-if="isPreviousActionVisible"
        class="font-weight-bold d-xl-flex d-lg-flex d-md-flex d-md-none d-sm-none d-none align-items-center justify-content-center"
        :vb_options="{ variant: 'outline-info', disabled: isPreviousActionDisabled }"
        role="button"
        @click="previousSegmentAction"
      >
        Volo precedente
      </vb-button>
      <span id="seat-map-next-action" class="d-inline-block">
        <vb-button
          class="font-weight-bold d-flex align-items-center justify-content-center"
          :vb_options="{ variant: 'info', disabled: isNextSegmentActionDisabled }"
          role="button"
          @click="handleNextSegmentAction"
        >
          <span>
            {{ nextSegmentActionLabel }}
          </span>
        </vb-button>
        <b-popover
          v-if="mustSelectSeats && isNextSegmentActionDisabled"
          target="seat-map-next-action"
          variant="primary"
          triggers="hover"
          placement="top"
        >
          Seleziona tutti i posti di ogni passeggero prima di continuare.
        </b-popover>
      </span>
    </div>
  </div>
</template>

<script>
import { formatPrice } from '@liveflight/utilities';
import { calculate_total_seats_price } from '@liveflight/utilities/seat-map';

export default {
  name: 'seat-map-footer',
  props: {
    mustSelectSeats: {
      type: Boolean,
      default: false,
    },
    isPreviousActionVisible: Boolean,
    isPreviousActionDisabled: Boolean,
    previousSegmentAction: Function,

    nextSegmentActionLabel: String,
    isNextSegmentActionDisabled: Boolean,
    handleNextSegmentAction: Function,

    parsedSelections: Object,
  },
  methods: {
    formatPrice,
  },
  computed: {
    totalAdditionalPrice() {
      const total = calculate_total_seats_price(this.parsedSelections);
      if (total <= 0) {
        return '';
      }
      return this.formatPrice(total);
    },
  },
};
</script>

<style lang="scss">
.seat-map-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  div:last-of-type {
    margin-left: auto;
  }
}
.seat-map-footer-actions {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
</style>
